import React from 'react';
import { Bell, AlertTriangle } from 'lucide-react';

export default function SuccessView({ 
  name = '', 
  email = '', 
  orderRef = '', 
  date = '', 
  shipping = '', 
  total = '', 
  hasOnOrder = false,
  reminderDate = null,
  onReturnHome = () => {}, 
  onDownloadPDF = () => {} 
}) {
  const copyRef = async () => {
    try {
      await navigator.clipboard.writeText(orderRef || '');
      alert('ID copié dans le presse-papiers');
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="min-h-[75vh] flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-4xl">
        <div className="text-center mb-8">
          <div className="mx-auto w-28 h-28 rounded-full bg-gradient-to-br from-emerald-900/30 to-blue-900/20 flex items-center justify-center mb-6 shadow-lg">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-12 h-12 text-emerald-400 stroke-emerald-400" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 6L9 17l-5-5" strokeDasharray="100" strokeDashoffset="0" style={{transition: 'stroke-dashoffset 400ms ease-out'}} />
            </svg>
          </div>
          <h1 className="text-4xl font-extrabold leading-tight">✅ Commande confirmée !</h1>
          <p className="mt-3 text-lg text-slate-400">
            {name ? (
              <>Merci <span className="font-bold text-white">{name}</span> !</>
            ) : (
              <>Merci !</>
            )}{' '}
            Votre demande est bien enregistrée — notre équipe s’en occupe et revient vers vous très vite.
          </p>
          <p className="mt-2 text-sm text-slate-500">Un e-mail de confirmation vous a été envoyé à <span className="font-medium text-white">{email}</span> — pensez à vérifier vos spams.</p>
        </div>

        <div className="bg-white/5 backdrop-blur-sm dark:bg-slate-800/60 p-6 rounded-2xl mb-6 border border-white/5 shadow-sm">
          <div className="flex items-center justify-between mb-3">
            <div>
              <div className="text-xs uppercase text-slate-400 tracking-wider">Résumé de votre commande</div>
              <div className="text-sm text-slate-300 mt-1">N° de commande</div>
            </div>
            <div className="text-right">
              <div className="flex items-center gap-3">
                <div className="font-black text-lg text-emerald-200">{orderRef}</div>
                <button onClick={copyRef} className="px-3 py-1 rounded-lg bg-slate-700/40 text-sm text-white">📋 Copier</button>
              </div>
              <div className="text-sm text-slate-400 mt-1">{date}</div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 mt-4">
            <div className="text-sm text-slate-400">Livraison</div>
            <div className="text-right font-medium text-white">{shipping || 'À déterminer'}</div>
            <div className="text-sm text-slate-400">Total TTC</div>
            <div className="text-right font-black text-white">{total || 'Demande de commande'}</div>
          </div>

          {/* Rappels de validation */}
          {(hasOnOrder || reminderDate) && (
            <div className="mt-6 pt-6 border-t border-white/10 space-y-3">
              {hasOnOrder && (
                <div className="flex items-start gap-3 text-amber-400 bg-amber-400/10 p-3 rounded-xl border border-amber-400/20">
                  <AlertTriangle className="w-4 h-4 mt-0.5 flex-shrink-0" />
                  <p className="text-xs font-medium">Vous avez validé que votre commande contient des articles sur commande avec des délais de livraison rallongés.</p>
                </div>
              )}
              {reminderDate && (
                <div className="flex items-start gap-3 text-blue-400 bg-blue-400/10 p-3 rounded-xl border border-blue-400/20">
                  <Bell className="w-4 h-4 mt-0.5 flex-shrink-0" />
                  <p className="text-xs font-medium">Vous avez demandé un rappel de renouvellement par email pour le : <span className="font-black">{new Date(reminderDate).toLocaleDateString('fr-FR')}</span></p>
                </div>
              )}
            </div>
          )}
        </div>

        <div className="bg-slate-900/30 p-4 rounded-2xl mb-6">
          <div className="flex flex-col sm:flex-row items-center gap-3 mb-6">
            <button onClick={() => onDownloadPDF && onDownloadPDF()} className="flex-1 bg-blue-600 text-white py-3 rounded-full font-black hover:bg-blue-700">Télécharger le PDF</button>
            <button onClick={onReturnHome} className="flex-1 bg-transparent border border-white/10 text-white py-3 rounded-full font-black">Retour au catalogue</button>
          </div>
        </div>

        <div className="text-sm text-slate-400 p-4 rounded-xl bg-slate-900/20">
          <div className="mb-2">Besoin d’un devis officiel / bon de commande ? Répondez simplement à l’e-mail reçu en ajoutant vos références internes.</div>
          <div className="mt-3 flex items-center gap-4 text-xs text-slate-400">
            <div>🔒 Vos informations restent chez DeepVision.</div>
          </div>
          <div className="mt-3 text-sm">Une question ? <a href="mailto:info@deepvision-hub.eu" className="text-blue-400 underline">Contactez-nous</a></div>
        </div>
      </div>
    </div>
  );
}

